import React from 'react'

const NeutralMark = ({ size = 36 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    data-testid="neutral-mark"
  >
    <rect x="15" y="3" width="22" height="22" rx="5" style={{ fill: 'var(--na-mark-back, #8fa9d3)' }} />
    <rect x="3" y="15" width="22" height="22" rx="5" style={{ fill: 'var(--na-mark-front, #2f4b7c)' }} />
  </svg>
)

export default NeutralMark
